import React from 'react'
import PropTypes from 'prop-types'

// Redux
import { connect } from 'react-redux'

// Firebase
import * as firebase from 'firebase'
import {
  DataLoader,
  UserRoomsLoader,
  TeamMembersLoader
} from '@fibo-app/fibo-collab-shared'

class FirebaseTeamsManager extends React.Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    teamId: PropTypes.string,
    userId: PropTypes.string
  }

  teamMetadataLoader : DataLoader
  teamMembersLoader : TeamMembersLoader
  teamEventTemplatesLoader: DataLoader
  userRoomsLoader: UserRoomsLoader

  constructor(props : Object) {
    super(props)
    this.checkProps(undefined, props.teamId)
  }

  componentWillReceiveProps(nextProps) {
    this.checkProps(this.props.teamId, nextProps.teamId)
  }

  checkProps(currTeamId, nextTeamId) {
    if (nextTeamId && currTeamId !== nextTeamId) {
      this.stopSyncingTeam()
      this.startSyncingTeam(nextTeamId)
    }
  }

  startSyncingTeam(teamId : string) {
    this.teamMetadataLoader = new DataLoader(firebase, 'teams', 'metadata')
    this.props.dispatch(this.teamMetadataLoader.startSyncing(teamId))

    this.teamMembersLoader = new TeamMembersLoader(firebase)
    this.props.dispatch(this.teamMembersLoader.startSyncing(teamId))

    this.teamEventTemplatesLoader = new DataLoader(firebase, 'teams', 'templates/events', true)
    this.props.dispatch(this.teamEventTemplatesLoader.startSyncing(teamId))

    this.userRoomsLoader = new UserRoomsLoader(firebase, teamId)
    this.props.dispatch(this.userRoomsLoader.startSyncing(this.props.userId))

    this.teamReportsEmailsLoader = new DataLoader(firebase, 'teams', 'reportsEmails')
    this.props.dispatch(this.teamReportsEmailsLoader.startSyncing(teamId))

    this.defaultMaterialsLoader = new DataLoader(firebase, 'teams', 'defaultMaterials')
    this.props.dispatch(this.defaultMaterialsLoader.startSyncing(teamId))

    this.defaultInvoiceItemsLoader = new DataLoader(firebase, 'teams', 'defaultInvoiceItems')
    this.props.dispatch(this.defaultInvoiceItemsLoader.startSyncing(teamId))
  }

  stopSyncingTeam() {
    if (this.teamMetadataLoader) {
      this.teamMetadataLoader.stopSyncing()
      this.teamMetadataLoader = null
    }

    if (this.teamMembersLoader) {
      this.teamMembersLoader.stopSyncing()
      this.teamMembersLoader = null
    }

    if (this.teamEventTemplatesLoader) {
      this.teamEventTemplatesLoader.stopSyncing()
      this.teamEventTemplatesLoader = null
    }

    if (this.userRoomsLoader) {
      this.userRoomsLoader.stopSyncing()
      this.userRoomsLoader = null
    }

    if (this.teamReportsEmailsLoader) {
      this.teamReportsEmailsLoader.stopSyncing()
      this.teamReportsEmailsLoader = null
    }

    if (this.defaultMaterialsLoader) {
      this.defaultMaterialsLoader.stopSyncing()
      this.defaultMaterialsLoader = null
    }

    if (this.defaultInvoiceItemsLoader) {
      this.defaultInvoiceItemsLoader.stopSyncing()
      this.defaultInvoiceItemsLoader = null
    }
  }

  render() {
    return null
  }
  
}

function mapStateToProps(state) {
  const props = {
    userId: state.firebase.userAuth.id,
    teamId: undefined
  }

  const userInfo = state.firebase.user
  if (!userInfo) {
    return props
  }

  const userTeams = userInfo.teams
  if (!userTeams || userTeams.loading) {
    return props
  }

  // Just sync first team
  // TODO move this to a selectionTeam key inside redux
  if (userTeams.value && userTeams.value.length > 0) {
    props.teamId = userTeams.value[0].teamId
  }
  return props
}

export default connect(mapStateToProps)(FirebaseTeamsManager)



// WEBPACK FOOTER //
// ./src/infra/components/FirebaseTeamsManager.js